var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--about-us_contents tw-container tw-mx-auto"
  }, [_c('div', {
    staticClass: "about-us-contents tw-grid tw-gap-5 sm:tw-gap-7.5 lg:tw-gap-x-7.5 lg:tw-gap-y-10"
  }, _vm._l(_vm.contents, function (content, index) {
    return _c('div', {
      key: `about-us-content-item-${index}`,
      class: _vm.itemClasses
    }, [_c('div', {
      class: [_vm.itemTextColumnClasses, {
        'xl:tw-col-start-2': !content.reverse,
        'lg:tw-col-start-6 xl:tw-col-start-8': content.reverse
      }]
    }, [_c('h2', {
      staticClass: "typography-h3 md:typography-page-title tw-mb-0"
    }, [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('p', {
      staticClass: "tw-text-15-21 tw-text-secondary tw-mt-2.5 tw-mb-5",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    }), _vm._v(" "), _vm.getLearnMoreLink(content.key) ? _c('nuxt-link', {
      staticClass: "learn-more-btn call-to-action dark no-outline btn-primary-hv tw-w-full md:tw-w-[160px] tw-min-h-[44px]",
      attrs: {
        "tag": "button",
        "to": _vm.getLearnMoreLink(content.key),
        "type": "button"
      },
      nativeOn: {
        "click": function ($event) {
          _vm.sendEventHandler({
            text: _vm.$t('scenes.about.us.learn-more-button-title'),
            url: _vm.getLearnMoreLink(content.key)
          });
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('scenes.about.us.learn-more-button-title')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      class: [_vm.itemImageColumnClasses, {
        'lg:tw-col-start-6 xl:tw-col-start-7': !content.reverse,
        'xl:tw-col-start-2': content.reverse
      }]
    }, [_c('nuxt-img', {
      staticClass: "tw-max-w-full tw-h-auto",
      attrs: {
        "src": content.img,
        "alt": content.title,
        "width": "445",
        "height": "455",
        "loading": "lazy"
      }
    })], 1)]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }